import { ReactElement, ReactNode } from 'react';

interface ConfirmFormBaseProps {
  onSubmit: () => void;
  children: ReactNode;
}

export function ConfirmFormBase({
  onSubmit,
  children,
}: ConfirmFormBaseProps): ReactElement {
  return (
    <form action="" className="max-w-[766px] w-full" onSubmit={onSubmit}>
      {children}
    </form>
  );
}
